// written at buildtime by fetch-default-toggles.js
export default {};
